export const COL_USERS = 'users';
export const COL_ANALYTICS_USERS = 'analytics_users';
export const COL_CONVERSATION = 'conversation';
export const COL_INSTANCE = 'instance';
export const COL_API_KEYS = 'api_keys';
export const COL_BRIEFING_SUBSCRIPTION = 'briefing_subscription';
export const COL_TOKEN_USAGE = 'token_usage';
export const COL_NEWS = 'news';
export const COL_EVAL_FUNNEL = 'eval_funnel';
export const COL_ASSETS = 'assets';
export const COL_ANTONIO_CONVERSATION = 'antonio_conversation';
export const COL_ANTONIO_IMAGE = 'antonio_image';
export const COL_REFERENCE_IMAGE = 'reference_image';
export const COL_ORGANIZATION = 'organization';
